import {createSelector} from 'reselect';
import props from '../../../../props';

export default createSelector(
    props.wallet.methods.zelle_deposit,
    (zelle_deposit) => {
        return {
            props: zelle_deposit[zelle_deposit.stage]
        }
    }
)